import { render, staticRenderFns } from "./PopUpDemo.vue?vue&type=template&id=50b57d4c&scoped=true"
import script from "./PopUpDemo.vue?vue&type=script&lang=js"
export * from "./PopUpDemo.vue?vue&type=script&lang=js"
import style0 from "./PopUpDemo.vue?vue&type=style&index=0&id=50b57d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b57d4c",
  null
  
)

export default component.exports